module.exports = __webpack_public_path__ + "media/images/goals-3-7ac9eeee34e16862ca32629a6949ce78.jpg";